export default "__VITE_ASSET__DrBPxsAd__"